module.exports = __webpack_public_path__ + "img/distence1.7007ed8.webp";